import React from "react";
import styles from "./RootLevelFooter.module.scss";
// Sub components
import RightSection from "./sub-components/RightSection";
import LeftSection from "./sub-components/LeftSection";

const RootLevelFooter = () => {
  return (
    <footer className={styles["root-level-footer"]}>
      <RightSection />
      <LeftSection />
    </footer>
  );
};

export default RootLevelFooter;
